<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.areaCoverageNo"
      :label="item.areaCoverageName"
      :value="item.areaCoverageNo"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { queryAreaCoverageVoByStationId, queryStationAreaId } from '@/api/transport/boundmerchant'
  export default {
    name: 'YdSeriviceAreaSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      query: {
        type: Object,
        required: true
      },
      areaType: {
        type: Number,
        default: () => 1 // 1 下单区域  2 分流区域  3 排除服务区域
      }
    },
    data() {
      return {
        options: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          const obj = this.options.find((item) => item.areaCoverageNo === val)
          this.$emit('onChange', obj)
        }
      }
    },
    watch: {
      query: {
        handler(nVal) {
          if (nVal) {
            if (this.areaType === 1) {
              this.queryServiceArea(nVal)
            }
            if (this.areaType === 2) {
              this.getRegionList(nVal)
            }
            if (this.areaType === 3) {
              this.getRegionList(nVal)
            }
          }
        },
        immediate: true
      }
    },
    methods: {
      // 查询下单区域
      async queryServiceArea({ merchantId, stationId, pickUpType }) {
        if (!merchantId || !stationId || !pickUpType) {
          throw new Error('下单区域接口查询缺少参数')
        }
        const { code, data } = await queryAreaCoverageVoByStationId(
          merchantId,
          stationId,
          pickUpType
        )
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.options = data
      },
      // 查询分流区域/排除服务区域
      async getRegionList({ stationId }) {
        if (!stationId) {
          throw new Error(`${this.areaType === 2 ? '分流区域' : '排除服务区域'}接口查询缺少参数`)
        }
        const { code, data } = await queryStationAreaId(stationId)
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        if (this.areaType === 2) {
          this.options = data.filter((item) => item.showType)
        }
        if (this.areaType === 3) {
          this.options = data.filter((item) => !item.showType)
        }
      },
      handleChange(e) {
        const obj = this.options.find((item) => item.areaCoverageNo === e)
        this.$emit('change', obj)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
